<template>
  <fin-dialog :value="value"
              class="d-flex align-center"
              :fullscreen="$vuetify.breakpoint.smAndDown"
              dense
              persistent
              @input="closeDialog()"
  >
    <template #title>
      <v-container class="fin-reduced-portfolio-details-title title px-0"
                   v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                   v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                   fluid>
        <v-row class="ma-0">
          <v-col class="pa-0">
            <h1 v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
              <fin-lexicon-text auto-solve
                                text='Dein Portfolio'/>
            </h1>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template>
      <v-container class="px-0"
                   v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                   v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                   fluid>
        <v-row class="mx-0 pb-0">
          <v-col class="pa-0">
            <p v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
               v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
              <fin-lexicon-text auto-solve
                                text='Hier kannst Du die Wertpapiere deines Portfolios sehen.'/>
            </p>
            <fin-tabs :no-item-content-padding="true"
                      :selected-tab="selectedTab"
                      :tab-items="mainTabItems"
                      style="background-color: #ebebe7; padding-bottom: 10px"
                      @tabChanged="tabIndex => selectedTab = tabIndex">
              <template #0>
                <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                             v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                             fluid>
                  <v-row>
                    <v-col cols="12">
                      <fin-data-table :headers="tableHeaders"
                                      :resolver="tableInstruments"/>
                    </v-col>
                  </v-row>
                </v-container>
              </template>

              <template v-for="(assetClass, index) in assetClasses"
                        v-slot:[index+1]>
                <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                             v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                             fluid :key="index">
                  <v-row>
                    <v-col cols="12">
                      <p v-if="!selectedInstruments[assetClass.id] || selectedInstruments[assetClass.id].length === 0">
                        Es gibt keine Instrumente von dieser Assetklasse in deinem Portfolio.
                      </p>
                      <fin-data-table v-else
                                      :key="index"
                                      :headers="tableHeaders"
                                      :resolver="tableInstruments"/>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
            </fin-tabs>
          </v-col>
        </v-row>

        <v-row class="mx-0 py-0">
          <v-col class="pa-0">
            <v-card-actions :class="'px-0 pt-2 pb-5 d-flex justify-end '+($vuetify.breakpoint.xs ? 'mb-4' : ' ')"
                            style="background-color: #ebebe7; padding-bottom: 10px">
              <v-btn outlined
                     @click="closeDialog">
                <span class="pl-4 pr-4">Zurück</span>
              </v-btn>
              <v-btn v-style:marginRight="$valueByBreakpoint($finMargin.right)"
                     dark
                     @click="closeDetailsAndConfirmPortfolio">
                <span class="pl-4 pr-4">Auswahl übernehmen</span>
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </fin-dialog>
</template>

<script>
import FinLexiconText from '@/components/common/lexicon/LexiconText'
import AssetClasses from "@/mocks/AssetClasses"
import FinTabs from "@/components/common/Tabs"
import FinDataTable from "@/components/common/DataTable/FinDataTable"
import {TablePresets} from "@/components/common/DataTable/DefaultHeaders"

export default {
  name: 'FinReducedPortfolioDetails',
  components: {
    FinDataTable,
    FinTabs,
    FinLexiconText
  },
  props: {
    /** Determines if the dialog is visible or not */
    value: {
      type: Boolean,
      default: false
    },
    /** The selected instruments: attributes for the different asset classes which contains arrays */
    selectedInstruments: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      assetClasses: AssetClasses.items,
      selectedTab: 0,
    }
  },
  computed: {
    mainTabItems() {
      const assetClassesNames = this.assetClasses.map((assetClass) => {
        return {name: assetClass.name, color: assetClass.color}
      })

      return [{name: "Übersicht"}, ...assetClassesNames]
    },
    tableHeaders() {
      const showInstrumentProfileAs = this.$route.path.includes('/finStrategist') ? "link" : "dialog"
      return TablePresets.createReducedPortfolioDetailsHeaders(showInstrumentProfileAs)
    },
    tableInstruments() {
      // "Übersicht" tab
      if (this.selectedTab === 0) {
        const instruments = []
        this.assetClasses.forEach(assetClass => {
          instruments.push(...this.selectedInstruments[assetClass.id])
        })
        return instruments
      }
      // asset class tabs
      else {
        return this.selectedInstruments[this.assetClasses[this.selectedTab - 1].id]
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeReducedDetails')
    },
    closeDetailsAndConfirmPortfolio() {
      this.$emit('closeReducedDetailsAndConfirmPortfolio')
    },
  },
}
</script>

<style scoped lang="scss">

</style>
